import { render, staticRenderFns } from "./ProcessDescriptionCard.vue?vue&type=template&id=3e991c80&"
import script from "./ProcessDescriptionCard.vue?vue&type=script&lang=js&"
export * from "./ProcessDescriptionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports